export default {
  hero: {
    tagline: "A native macOS Minecraft launcher built with SwiftUI, offering smooth performance, full mod loader support, Microsoft account login, and intuitive game management.",
    requirement: "Requires macOS 14.0 or later",
    loading: "Getting latest version...",
    fetchError: "Failed to get version",
    download: "Download",
    appleChip: "Apple Silicon",
    intel: "Intel",
  },
  features: {
    title: "Powerful features, beautifully simple",
    subtitle: "From account sign-in to mod management, the complex becomes effortless.",
    items: [
      {
        title: "Native Swift, blazing fast",
        body: "Built with SwiftUI for instant launches and fluid interactions, with full support for Dark Mode and the latest macOS features.",
      },
      {
        title: "Sign in with Microsoft",
        body: "Connect your Microsoft and Xbox accounts securely, switch between profiles in a click, and stay signed in.",
      },
      {
        title: "Skins, always in sync",
        body: "Preview and switch skins in a click, with your character's look always up to date.",
      },
    ],
    moreTitle: "And so much more",
    moreCta: "There's even more waiting for you inside the launcher.",
    moreCtaLink: "Download to explore",
    more: [
      {
        title: "Mod loaders",
        body: "Fabric, Forge, NeoForge and Quilt — install and switch with one click.",
      },
      {
        title: "Game instances",
        body: "Keep versions and instances separate, so mods and saves never conflict.",
      },
      {
        title: "Automatic updates",
        body: "Powered by Sparkle, updates let you know the moment a new version is released.",
      },
      {
        title: "Native UI",
        body: "Built entirely with native macOS controls and design language, following the system's light and dark appearance automatically.",
      },
      {
        title: "Languages",
        body: "The interface speaks 22 languages, covering regions worldwide.",
      },
      {
        title: "Open source",
        body: "Free and open source under AGPL v3 — transparent by design.",
      },
    ],
  },
  contributors: {
    github: "GitHub Contributors",
    core: "Core Contributors",
    contributions: "contributions",
  },
  navbar: {
    docs: "Docs",
    changelog: "Changelog",
    discussions: "Discussions",
    reportIssue: "Report Issue",
  },
  footer: {
    product: "Product",
    download: "Download",
    userGuide: "User Guide",
    changelog: "Changelog",
    community: "Community",
    discussions: "Discussions",
    qqGroup: "QQ Group",
    bilibili: "Bilibili",
    feedback: "Feedback",
    reportIssue: "Report Issue",
    legal: "Legal",
    license: "AGPL v3 License",
    copyright: "All rights reserved.",
    disclaimer: "Swift Craft Launcher is not affiliated with Mojang Studios or Microsoft. Minecraft is a registered trademark of Mojang Studios.",
  },
};
